module.exports = __webpack_public_path__ + "static/media/stepDisinfect.213ebb02.png";